//Lib 
import { mapState } from "vuex";

// Extend
import baseFixedRentalService from '@/scripts/fixedRental/baseFixedRentalService';

// Api
import api from '@/api/baseApi';

// Constant 
import { ROUTE_URL } from '@/constant/route';
import { API_CALL_STATUS, POPUP_ID } from "@/constant/baseConstant";
import { SERVICE_TYPE, MACHINE_LIST_FILTER_BY, RENTAL_REQUEST_TYPE } from '@/constant/rental';
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { PERIOD, ELEMENT_LIST_PERIOD, FIXED_RENTAL_STATUS, ELEMENT_LIST_PERIOD_ON_CREATED } from "@/constant/fixedRental";

// Component 
import OneInListNoMachineAvailable from "@/views/component/FixedRental/Notification/OneInListNoMachineAvailable";
import Information from "@/views/component/RentalService/Information";
import Lable from "@/views/component/RentalService/Lable";

// Function 
const queryString = require('query-string');

export default {

    extends: baseFixedRentalService,

    components: {
        OneInListNoMachineAvailable,
        Information,
        Lable,
    },

    computed: {
        ...mapState({
            user: state => state.auth.user,
            tempBalance: state => state.auth.tempBalance,
        }),
        ELEMENT_LIST_PERIOD_LIST() {
            return process.env.VUE_APP_CODE === 'IRENDER_GPU_VN' ? ELEMENT_LIST_PERIOD_ON_CREATED(this.targetImage.packageId) : ELEMENT_LIST_PERIOD;
        },
        listPeriod() {
            return process.env.VUE_APP_CODE === 'IRENDER_GPU_VN' ? ELEMENT_LIST_PERIOD_ON_CREATED(this.targetImage.packageId) : ELEMENT_LIST_PERIOD;
        }
    },

    data() {

        return {
            routeUrl: ROUTE_URL,
            //listPeriod: ELEMENT_LIST_PERIOD,
            fixedRentalStatus: FIXED_RENTAL_STATUS,

            packageList: [],

            machineListRequest: {
                serviceType: SERVICE_TYPE.GPUHUB,
                filterBy: MACHINE_LIST_FILTER_BY.NOT_FIXED_RENTAL,
                listPackageId: [],
                orderBy: 'A.CREATED_AT',
                directionSort: 'DESC',
            },

            request: {
                campaignName: null,
                period: PERIOD.THREE_HOUR,
                periodUnit: 1,
                totalCost: 0,
                continueRunning: false,
            },

            machineList: [],
            servicePackageList: [],
            listPackageSelected: [],
        };
    },

    mounted() {
        this.machineListRequest.serviceType = this.serviceType;
    },

    props: {
        serviceType: {
            type: Number,
            default: null,
        },
    },

    methods: {

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        //#region Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.FIXED_RENTAL_EXISTING_MACHINE);
        },
        //#endregion 

        //#region Skip description
        skipDescription(value) {
            this.isShowInformation = value;
            if (!value) {
                this.machineListView(true);
            }
        },
        //#endregion

        //#region Create package list Element
        createPackageListElement(responsedData) {

            function compare(a, b) {
                const bandA = a.packageName.toUpperCase();
                const bandB = b.packageName.toUpperCase();

                let comparison = 0;
                if (bandA > bandB) {
                    comparison = 1;
                } else if (bandA < bandB) {
                    comparison = -1;
                }
                return comparison;
            }

            responsedData.sort(compare);

            let list = [];
            responsedData.forEach(element => {
                if (list.filter(x => x.value === element.packageId).length === 0) {
                    list.push({
                        label: element.packageName,
                        value: element.packageId
                    });
                }
            });

            this.packageList = list;
        },
        //#endregion 

        //#region Machine list view
        machineListView(isFirstTime) {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            api.baseRequest(SETTINGS_RENTAL_API.MACHINE_LIST_VIEW, null, `?${queryString.stringify(this.machineListRequest)}`)
                .then((res) => {
                    let responsedData = res.data;
                    this.machineList = responsedData.filter(x => x.packageId !== '28');
                    if (isFirstTime === true) {
                        this.createPackageListElement(responsedData);
                    }
                    this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.machineList);
                })
                .catch(error => {
                    this.processCatchApiRequest(error, this.$t('dialog.requestFailed'))
                });
        },
        //#endregion

        //#region filter list
        filterList() {
            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            }
            let array = this.machineList.filter(x => x.isSelected).map(x => x.packageId)
            this.listPackageSelected = array.filter(onlyUnique);
        },
        //#endregion

        //#region Fixed rental create
        create() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                this.filterList();
                let data = {
                    campaignName: this.request.campaignName,
                    listMachineId: this.machineList.filter(x => x.isSelected).map(x => x.id),
                    period: this.request.period,
                    periodUnit: this.request.periodUnit,
                    continueRunning: this.request.continueRunning,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                this.fixedRentalCreate(
                    data,
                    () => { this.closeThisPopup() }
                )
            }, this.smoothTimeOut);
        },
        //#endregion

        //#region Rental request create
        rentalRequestCreate() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    type: RENTAL_REQUEST_TYPE.NOTIFY_MACHINE_AVAILABLE,
                    packageId: this.listPackageSelected[0],
                    operatingSystem: this.machineList.filter(x => x.isSelected)[0].operatingSystem,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                this.baseRentalRequestCreate(
                    data,
                    this.targetImage,
                    () => { this.closeThisPopup() }
                )
            }, this.smoothTimeOut);
        },
        //#endregion
    },
}